import { css } from 'styled-components';
import {
  Container,
  StyledRichText,
} from '../../../../../components/Footer/FooterCompliance/styles';
import { colors } from '../../../colors';

export default css`
  &${Container} {
    border: none;
    padding-top: 0;
  }

  ${StyledRichText} {
    a {
      color: ${colors.core01};
    }
  }
`;
